import React, { useCallback, useEffect, useState,useImperativeHandle,forwardRef, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { find, map, set,filter } from "lodash";
import Countdown, { zeroPad } from "react-countdown";
import ApiEngine from "util/ApiEngine";
import {
	ApiKey,
	ApiUrl,
	SessionKey,
	WebUrl,
	TransactionType,
	BankingChannel,
	PanelType,
	DEFAULT_PAGE_SIZE,
} from "util/Constant";
import { setLoginModal, setRewardType } from "redux/AppAction";
import { useTranslation } from "react-i18next";
import { bindMember, setBusy, setIdle, setSpinWheelListModal, setSpinWheelLoaded } from "redux/AppAction";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import VIcon from "components/custom/Icon";
import { themeIcons } from "config/theme";
import { stringIsNullOrEmpty } from '../../util/Util'
import SpinWheelListPopUpModal from "components/template_1/spinWheel/SpinWheelListPopUpModal";
import "../../assets/css/spinwheel.css"
import { AnimatedList } from "react-animated-list";

const SpinWheel = forwardRef(( props,ref ) => {
	const { t, i18n } = useTranslation();
	let _history = useHistory();
	let _location = useLocation();
	const _dispatch = useDispatch();
	const _userData = useSelector((state) => state.authState.userData);
	const memberData = useSelector((state) => state.appState.member);
  const [iframeSrc, setIframeSrc] = useState('');
  var { heartBeat } = useSelector((state) => state.authState);
  
  const [spinWheelEnabled, setSpinWheelEnabled] = useState(false);
  const [showSpinWheelForGuest, setShowSpinWheelForGuest] = useState(false);
  const [shouldShowSpinWheel, setShouldShowSpinWheel] = useState(false);
  const [clickCloseSpinWheel, setClickCloseSpinWheel] = useState(false);
  const [showSpinWheelListPopup,setShowSpinWheelListPopup] = useState(false);
  const companyIcons = useSelector((state) => state.appState.companyIcons);
  const [rewardImg,setRewardImg]=useState(require("../../assets/img/icon/spin-wheel-btn.svg"));
  const [iconColor, setIconColor] = useState('#FFF');
  const spinWheelLoaded = useSelector((state) => state.appState.spinWheelLoaded);
  const [advancedSettings, setAdvancedSettings] = useState([]);
  const [shouldShowIcon, setShouldShowIcon] = useState(false);
  const [showRewardForGuest, setShowRewardForGuest] = useState(false);
  const [isRewardListOpen, setIsRewardListOpen] = useState(false);
  const rewardType = useSelector((state) => state.appState.rewardType);
  const spinWheelListModal = useSelector((state) => state.appState.spinWheelListModal);
  const [seqPos,setSeqPos]=useState(1);
  const { isPromoInfo, onClickPromoInfo, promoInfoId, chatRef } = props;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isScrolling, setIsScrolling] = useState(false);
  const scrollTimeout = useRef(null);

	useEffect(() => {
		init();

    const parentElement = document.querySelector('.page-container');
    
    if(parentElement){
    const backgroundColor = window.getComputedStyle(parentElement).backgroundColor; 
    const isDarkTheme = isDarkBackground(backgroundColor);
    setIconColor(isDarkTheme ? '#FFF' : '#383838');
    }
	}, []);

  //useEffect(() => {
  //  init()
  //}, [heartBeat]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolling(true);

      // Clear previous timeout
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }

      // Detect scroll stop
      scrollTimeout.current = setTimeout(() => {
        setIsScrolling(false);
      }, 600); // adjust delay if needed
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!chatRef.current) return;
  
    const base = seqPos === 2 ? 2 : 1;
    const offset = shouldShowIcon ? 1 : 0;
    var value=base + offset;

    value=(!isMobile && value===2 && !shouldShowIcon)?1:value;
    chatRef.current.changePos(value);
  
  }, [shouldShowIcon, seqPos]);
  
  useImperativeHandle(ref, () => ({
    changePos: (seq) => {
      setSeqPos(seq);
    },
  }));

  const spinWheelSetting = useSelector(
    (state) => state.appState.spinWheelSetting
  );
 const rewardAdvancedSetting = useSelector(
    (state) => state.appState?.rewardAdvancedSetting
  );

  async function init() {
    // Get spinwheel settings
    if(!spinWheelLoaded) {
      let rewardIcon = find(companyIcons, { iconCategory: "floating_icon",iconName: "Floating Reward" });
      
      if(rewardIcon){
        setRewardImg(rewardIcon.iconImage);
      }
      // let responseJson = await ApiEngine.get(
      //   ApiUrl._API_GET_REWARD_SETTINGS
      // );

      // if(responseJson[ApiKey._API_SUCCESS_KEY]){

        var rewardEnabled = false;
        var showForGuestTemp = false;
        var showFloatingIcon = false;


        let settings = rewardAdvancedSetting
        setAdvancedSettings(rewardAdvancedSetting)


        // const hasValidSetting = settings.some(
        //   s =>
        //     s?.status === true &&
        //     (s?.showForGuest === true || s?.showFloatingIcon === true)
        // );

        // if (hasValidSetting && ) {

        //   setShowIcon(true)
        //   console.log("At least one setting matches the condition");
        // } else {
        //   setShowIcon(false)

        //   console.log("No setting matches the condition");
        // }
          // var spinWheelEnabled = false;
          // var showSpinWheelForGuestTemp = false;
          // var showSpinWheelFloatingIcon = false;
        
        let hasStatus = false
        let hasShowForGuest = false
        let hasFloatingIcon = false

        if(settings?.length > 0){
          hasStatus = settings.some(s =>s?.status === true );
          hasShowForGuest = settings.some(s =>s?.showForGuest === true );
          hasFloatingIcon = settings.some(s =>s?.showFloatingIcon === true );
        }
       

      
        if(hasStatus){
          rewardEnabled = true;
        }

        if(hasShowForGuest){
          showForGuestTemp = true;
          setShowRewardForGuest(true);
        }
         if(hasFloatingIcon){
          showFloatingIcon=true;
        }

        if(heartBeat && rewardEnabled && !clickCloseSpinWheel && showFloatingIcon) {
          setShouldShowIcon(true);
        } else if(!heartBeat && rewardEnabled && showForGuestTemp && !clickCloseSpinWheel && showFloatingIcon) {
          setShouldShowIcon(true);
        } else {
          setShouldShowIcon(false);
        }

        _dispatch(setSpinWheelLoaded(true));
      // }
    }
  }

  const checkShouldShowReward = (setting)=>{
		if(heartBeat && setting.status && setting.showFloatingIcon) {
			return true
		} else if(!heartBeat && setting.status && setting.showForGuest) {
			return true
		} else {
			return false
		} 

	} 

  const [imgLoad, setImgLoad] = useState(false);

  const isDarkBackground = (bgColor) => {
    const rgb = bgColor.match(/\d+/g);
    if (rgb) {
      const r = parseInt(rgb[0], 10);
      const g = parseInt(rgb[1], 10);
      const b = parseInt(rgb[2], 10);
      return (r * 0.299 + g * 0.587 + b * 0.114) < 128;
    }
    return false;
  };


	return (
    <>
      {/* {shouldShowIcon && _location.pathname !== "/"+ WebUrl.getCurrentLocale() +"/livechat" && (
        <div id="spin-wheel">
          <div
            style={{ position: "relative", display: "inline-block", padding: "10px" }}
            onClick={() => {
              if (!heartBeat && showSpinWheelForGuest) {
                _dispatch(setLoginModal(true));
              } else {
                _dispatch(setSpinWheelListModal(true));
              }
            }}>
          
            {imgLoad && (
              <div
                className="spin-wheel-close" style={{ color: iconColor }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShouldShowSpinWheel(false);
                  setClickCloseSpinWheel(true);
                }}
              >
                <VIcon icon={themeIcons.close} className="vicon" />
              </div>
            )}
            <img className="wheel-icon" alt="spin-wheel-icon" src={rewardImg} onLoad={() => setImgLoad(true)} />
            {imgLoad && (<div className="spin-wheel-label">{t("SPIN_NOW")}</div>)}
          </div>
        </div>
      )} */}

      {shouldShowIcon && _location.pathname !== "/"+ WebUrl.getCurrentLocale() +"/livechat" &&  advancedSettings.some(item => item.status && (item.iconImage || item.defaultImage)) && (
        <div id="spin-wheel" className={`spin-wheel n-${seqPos} ${isScrolling ? "hide-partial" : ""}`}>
        {isRewardListOpen && (
            <div className={`float-reward-icon-group ${isRewardListOpen ? "open" : ""}`}>
                  <AnimatedList animation={"grow"}>
                    {advancedSettings.length > 0 && advancedSettings.map((item, index) => {

                        if (!checkShouldShowReward(item) || (!item.iconImage && !item.defaultImage)) 
                        {
                          return "";
                        } 

                        return(
                          <div
                            key={index}
                            className="float-channel-circle-icon"
                            onClick={()=>{
                              setIsRewardListOpen(false);
                              if(!heartBeat){
                                _dispatch(setLoginModal(true));

                              }else{
                                 _dispatch(setRewardType(item.typeId,item.typeName));
                                 _dispatch(setSpinWheelListModal(true));
                              }
                             
                            }}
                          >
                            <img src={item?.iconImage || item?.defaultImage} alt="Icon" />
                          </div>
                        )
                      })
                    }
                    
                </AnimatedList>
            </div>)
          }
          {
            rewardImg && (
              <div
                style={{ position: "relative", display: "inline-block", padding: "10px" }}
                onClick={() => {
           
                  if (!heartBeat && showRewardForGuest) {
                    // _dispatch(setLoginModal(true));
                      setIsRewardListOpen(!isRewardListOpen)

                  } else {
                    // _dispatch(setSpinWheelListModal(true));
                    setIsRewardListOpen(!isRewardListOpen)
                  }
                }}>
              
                {imgLoad && (
                  <div
                    className="spin-wheel-close" style={{ color: iconColor }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShouldShowSpinWheel(false);
                      setShouldShowIcon(false)
                      setClickCloseSpinWheel(true);
                    }}
                  >
                    <VIcon icon={themeIcons.close} className="vicon" />
                  </div>
                )}
                <img className="wheel-icon" alt="spin-wheel-icon" src={rewardImg} onLoad={() => setImgLoad(true)} />
                {/* {imgLoad && (<div className="spin-wheel-label">{t("SPIN_NOW")}</div>)} */}
              </div>
            )
          }
     
        </div>
      )}
      <SpinWheelListPopUpModal/>
    </>
	);
});

export default SpinWheel;
